import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import donationBannerImg from "../../../assets/imgs/donation-banner-img.webp";
import LaptopImg from "../../../assets/imgs/gm-video.webp";
import DM1 from "../../../assets/imgs/data-modal-img-1.webp";
import DM2 from "../../../assets/imgs/data-modal-img-2.webp";
import DM3 from "../../../assets/imgs/data-modal-img-3.webp";

import "./css/DonationManagement.css";
import { Helmet } from "react-helmet";
const DonationManagement = () => {
  useEffect(() => {
    const violation = document.getElementById("top-menu");
    window.scrollTo({
      top: violation.offsetTop,
      // behavior: "smooth",
    });
  }, []);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Helmet>
        <title>Donation Management System | Donor Management CRM</title>
        <meta name="keywords" content="" />
        <meta
          name="description"
          content="Elevate your philanthropy with our streamlined Donation Management System. Effortlessly manage, track, and optimize contributions for meaningful impact. Explore our Donation Management System today."
        />
      </Helmet>
      <header>
        <div class="container-fluid">
          <div class="banner-wrap">
            <div class="banner-slider">
              <div class="banner-slide g-banner">
                <div class="container">
                  <div class="sliderContent">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="slideTxt">
                          <div class="darkTxt g-darkTxt">
                            Donation
                            <br /> Management Services
                          </div>
                          <p>
                            Digitize & Automate Your Fundraising Activities{" "}
                          </p>
                          <ul>
                            <li>Low Code</li>
                            <li>Truly Compliant</li>
                            <li>Cloud-ready</li>
                            <li>Customizable</li>
                            <li>Secure</li>
                            <li>Unlimited Users</li>
                          </ul>
                          <div class="homesliderbtn">
                            {" "}
                            <a
                              href="#getStrated"
                              class="rc-primary-btn rc-large-btn rc-btn"
                              tabindex="0"
                              aria-label="Get a Demo Button"
                            >
                              Schedule a demo <i class="icon-arrow"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="g-mask">
                          <img
                            class="svg-normal-mask"
                            alt="A Cloud-based charity-focused Nonprofit Software"
                            src={donationBannerImg}
                            width="1000"
                            height="667"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <main>
        <section class="highlight-Section pb-2 hs-top-cc">
          <div class="container">
            <div class="row">
              <div class="col-md-12 text-center">
                <p>
                  Right Cause Donation Management System is a nonprofit CRM
                  suite powered by{" "}
                  <a
                    href="https://www.dynamicscrmconsulting.com/"
                    target="_blank"
                  >
                    Microsoft Dynamics 365 CRM
                  </a>
                  . It operates on the secure Microsoft Cloud platform,
                  providing end-to-end nonprofit-focused capabilities. This
                  system offers charity-specific features to enhance donor
                  engagement and streamline fundraising efforts. It includes
                  robust functionalities for tracking fundraising activities,
                  managing volunteers, handling grant management, and more,
                  making it a comprehensive solution for nonprofit
                  organizations.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section class="highlight-Section hs-sec-cc">
          <div class="container">
            <div class="row align-items-center text-center">
              <div
                class="col-md-12 col-lg-10 offset-lg-1 mt-xs-3"
                data-aos="zoom-in"
              >
                <h1 class="h1">The Right Cause Highlights</h1>
                <p>
                  The Right Cause Solution lets you operate more efficiently,
                  reach, and engage new donors, and retain and expand existing
                  donors. All are delivered in secure Microsoft —the most
                  secure, reliable, and scalable cloud that truly integrates
                  core solutions for the specific needs of Nonprofits and
                  Charities.{" "}
                </p>
              </div>
              <div class="col-md-4 col-lg-3 text-center" data-aos="fade-up">
                <div class="solutionIcon">
                  <div>
                    {" "}
                    <span class="icon-Constituent">
                      <span class="path1"></span>
                      <span class="path2"></span>
                    </span>
                  </div>
                  <p class="mt-2">Constituent Management</p>
                </div>
              </div>
              <div class="col-md-4 col-lg-3 text-center" data-aos="fade-up">
                <div class="solutionIcon">
                  <div>
                    <span class="icon-Donation-Management"></span>
                  </div>
                  <p class="mt-2">Donation Management</p>
                </div>
              </div>
              <div class="col-md-4 col-lg-3 text-center" data-aos="fade-up">
                <div class="solutionIcon">
                  <div>
                    <span class="icon-gift"></span>
                  </div>
                  <p class="mt-2">Fundraising across gift types</p>
                </div>
              </div>
              <div class="col-md-4 col-lg-3 text-center" data-aos="fade-up">
                <div class="solutionIcon">
                  <div>
                    <span class="icon-engagement"></span>
                  </div>
                  <p class="mt-2">Grants/Awards management</p>
                </div>
              </div>
              <div class="col-md-4 col-lg-3 text-center" data-aos="fade-up">
                <div class="solutionIcon">
                  <div>
                    <span class="icon-Volunteer"></span>
                  </div>
                  <p class="mt-2">Volunteer Management</p>
                </div>
              </div>
              <div class="col-md-4 col-lg-3 text-center" data-aos="fade-up">
                <div class="solutionIcon">
                  <div>
                    <span class="icon-Events-Management"></span>
                  </div>
                  <p class="mt-2">Events Management</p>
                </div>
              </div>
              <div class="col-md-4 col-lg-3 text-center" data-aos="fade-up">
                <div class="solutionIcon">
                  <div>
                    <span class="icon-Membership-Management"></span>
                  </div>
                  <p class="mt-2">Membership Management</p>
                </div>
              </div>
              <div class="col-md-4 col-lg-3 text-center" data-aos="fade-up">
                <div class="solutionIcon">
                  <div>
                    <span class="icon-Reports"></span>
                  </div>
                  <p class="mt-2">Reports & Dashboards</p>
                </div>
              </div>
              <div class="col-md-4 col-lg-3 text-center" data-aos="fade-up">
                <div class="solutionIcon">
                  <div>
                    <span class="icon-workflows"></span>
                  </div>
                  <p class="mt-2">Custom Workflows</p>
                </div>
              </div>
              <div class="col-md-4 col-lg-3 text-center" data-aos="fade-up">
                <div class="solutionIcon">
                  <div>
                    <span class="icon-Level-based"></span>
                  </div>
                  <p class="mt-2">Level-based Access</p>
                </div>
              </div>
              <div class="col-md-4 col-lg-3 text-center" data-aos="fade-up">
                <div class="solutionIcon">
                  <div>
                    <span class="icon-Automated-Triggers"></span>
                  </div>
                  <p class="mt-2">Insights and Automated Triggers</p>
                </div>
              </div>
              <div class="col-md-4 col-lg-3 text-center" data-aos="fade-up">
                <div class="solutionIcon">
                  <div>
                    <span class="icon-On-demand"></span>
                  </div>
                  <p class="mt-2">On-demand Integrations </p>
                </div>
              </div>
              <div class="col-lg-12 text-center mt-3">
                <a
                  href="#getStrated"
                  class="rc-primary-btn rc-large-btn rc-btn"
                  tabindex="0"
                  aria-label="Schedule your free, customized demo"
                  contenteditable="false"
                >
                  Schedule your free, customized demo <i class="icon-arrow"></i>
                </a>
              </div>
            </div>
          </div>
        </section>
        <section class="strengthenView sv-cc">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-md-12 col-lg-6">
                <h3 class="h1">Engage and Nurture your Donors and Prospects</h3>
                <p>
                  The Right Cause solution offers an enterprise-level
                  advancement system that integrates fundraising best practices
                  and can be customized to align with your organization's unique
                  processes and procedures. It enables efficient management of
                  constituent relationships while maximizing their value and
                  impact.
                </p>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="acc-container">
                  <div class="accordion" id="accordionExample">
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingOne">
                        <button
                          class="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseOne"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                        >
                          Holistic Constituent View
                        </button>
                      </h2>
                      <div
                        id="collapseOne"
                        class="accordion-collapse collapse show"
                        aria-labelledby="headingOne"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          Strengthen relationships by consolidating contact and
                          interaction data into a single constituent profile.
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingTwo">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseTwo"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                        >
                          Multi-Dimensional Relationships
                        </button>
                      </h2>
                      <div
                        id="collapseTwo"
                        class="accordion-collapse collapse"
                        aria-labelledby="headingTwo"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          Foster stronger connections across volunteers, remote
                          teams, departments, and programs.
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingThree">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseThree"
                          aria-expanded="false"
                          aria-controls="collapseThree"
                        >
                          Enhanced Understanding of Constituents
                        </button>
                      </h2>
                      <div
                        id="collapseThree"
                        class="accordion-collapse collapse"
                        aria-labelledby="headingThree"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          Utilize automated business rules to identify
                          constituencies and gain comprehensive insights into
                          their relationships with your organization.
                        </div>
                      </div>
                    </div>

                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingFour">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseFour"
                          aria-expanded="false"
                          aria-controls="collapseFour"
                        >
                          Improved Constituent Tracking
                        </button>
                      </h2>
                      <div
                        id="collapseFour"
                        class="accordion-collapse collapse"
                        aria-labelledby="headingFour"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          Move donors through giving levels more efficiently and
                          monitor constituents throughout their lifecycle.
                        </div>
                      </div>
                    </div>

                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingFive">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseFive"
                          aria-expanded="false"
                          aria-controls="collapseFive"
                        >
                          Complete Constituent View
                        </button>
                      </h2>
                      <div
                        id="collapseFive"
                        class="accordion-collapse collapse"
                        aria-labelledby="headingFour"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          Gain a comprehensive understanding of relationships
                          and maintain an institutional memory by easily
                          documenting every interaction with prospects and
                          donors.
                        </div>
                      </div>
                    </div>

                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingSix">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapsesix"
                          aria-expanded="false"
                          aria-controls="collapsesix"
                        >
                          Grants Reporting & Analytics
                        </button>
                      </h2>
                      <div
                        id="collapsesix"
                        class="accordion-collapse collapse"
                        aria-labelledby="headingFour"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          Gain immediate visibility into your grant-related data
                          with intuitive, real-time analytics on embedded Power
                          BI Dashboard. We can also help you build custom
                          dashboard for different KPIs.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="encourage-giving-Section">
          <div class="container">
            <div class="row align-items-center text-center">
              <div
                class="col-md-12 col-lg-10 offset-lg-1 mt-xs-3"
                data-aos="zoom-in"
              >
                <h1 class="h1">
                  Encourage giving amongst your congregation using Microsoft
                  Cloud.
                </h1>
                <p>
                  Automate critical processes to free up your leadership team to
                  focus on serving your congregation, rather than being tied
                  down by administrative tasks. Our cloud-based nonprofit CRM
                  solution seamlessly automates and streamlines member data
                  management, integrates giving, and supports your ministry, all
                  without the need for coding. Say goodbye to manual tasks and
                  hello to more time spent on what truly matters – serving your
                  community.
                </p>
              </div>
              <div class="col-md-4 col-lg-3 text-center" data-aos="fade-up">
                <div class="solutionIcon">
                  <div>
                    {" "}
                    <span class="icon-Volunteer-Scheduling">
                      <span class="path1"></span>
                      <span class="path2"></span>
                    </span>
                  </div>
                  <p class="mt-2">Volunteer Scheduling</p>
                </div>
              </div>
              <div class="col-md-4 col-lg-3 text-center" data-aos="fade-up">
                <div class="solutionIcon">
                  <div>
                    <span class="icon-faith"></span>
                  </div>
                  <p class="mt-2">Worship Planning</p>
                </div>
              </div>
              <div class="col-md-4 col-lg-3 text-center" data-aos="fade-up">
                <div class="solutionIcon">
                  <div>
                    <span class="icon-Grants-Management"></span>
                  </div>
                  <p class="mt-2">Grants Management</p>
                </div>
              </div>
              <div class="col-md-4 col-lg-3 text-center" data-aos="fade-up">
                <div class="solutionIcon">
                  <div>
                    <span class="icon-engagement"></span>
                  </div>
                  <p class="mt-2">Donor Engagement </p>
                </div>
              </div>
              <div class="col-md-4 col-lg-3 text-center" data-aos="fade-up">
                <div class="solutionIcon">
                  <div>
                    <span class="icon-On-demand"></span>
                  </div>
                  <p class="mt-2">On-demand Integrations</p>
                </div>
              </div>
              <div class="col-md-4 col-lg-3 text-center" data-aos="fade-up">
                <div class="solutionIcon">
                  <div>
                    <span class="icon-social-media"></span>
                  </div>
                  <p class="mt-2">Social Media Automation </p>
                </div>
              </div>
              <div class="col-md-4 col-lg-3 text-center" data-aos="fade-up">
                <div class="solutionIcon">
                  <div>
                    <span class="icon-Events-Registration"></span>
                  </div>
                  <p class="mt-2">Events Registration and Management </p>
                </div>
              </div>
              <div class="col-md-4 col-lg-3 text-center" data-aos="fade-up">
                <div class="solutionIcon">
                  <div>
                    <span class="icon-Venue"></span>
                  </div>
                  <p class="mt-2">Venue Management</p>
                </div>
              </div>
              <div class="col-md-4 col-lg-3 text-center" data-aos="fade-up">
                <div class="solutionIcon">
                  <div>
                    <span class="icon-multilingual-options"></span>
                  </div>
                  <p class="mt-2">Multilingual Options</p>
                </div>
              </div>
              <div class="col-md-4 col-lg-3 text-center" data-aos="fade-up">
                <div class="solutionIcon">
                  <div>
                    <span class="icon-Sponsorship"></span>
                  </div>
                  <p class="mt-2">Sponsorship Management</p>
                </div>
              </div>
              <div class="col-md-4 col-lg-3 text-center" data-aos="fade-up">
                <div class="solutionIcon">
                  <div>
                    <span class="icon-post-event"></span>
                  </div>
                  <p class="mt-2">Post Event-Lead Management</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="videoDiv" class="videoPlay_section donationVideo">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-md-12 text-center mb-3">
                <h1 class="h1">
                  Right Cause Grants Accelerator- A standalone <br />
                  Grant Management Module
                </h1>
                <p>
                  The Right Cause Grants Accelerator module comes with
                  additional capabilities for Grantmakers as well as Grantees
                  who can leverage Microsoft’s Dataverse, also known as Common
                  Data Model to solve critical grant management processes.
                </p>
              </div>
              <div class="col-md-6 col-lg-6 mb-5 mb-cc-none">
                {/* <picture>
                                    <source srcset="img/laptop-img.webp" width="752" height="417" type="image/webp">
                                    <source srcset="img/laptop-img.png" type="image/jpeg">
                                    <img data-src="img/laptop-img.png" alt="about right cause nonprofit software" width="752" height="417" src="img/laptop-img.png">
                                </picture> */}
                <button
                  type="button"
                  variant="primary"
                  onClick={handleShow}
                  className="btn videoplay-Btn"
                  // data-bs-toggle="modal"
                  // data-bs-target="#videoPlayModal"
                  aria-label="Play Video Button"
                ></button>
                <img
                  alt="about right cause nonprofit software"
                  src={LaptopImg}
                  width="752"
                  height="417"
                  className="vplaceholder"
                />
              </div>
              <div class="col-md-6 col-lg-6" data-aos="zoom-out-right">
                <strong>
                  The solution is highly suitable and customizable for the
                  organization considering to shift their processes on Cloud, it
                  provides both online and grant-tracking functionality in a
                  single package. It comes with pre-built features like:
                </strong>
                <ul class="g-list">
                  <li>Fund Indicators</li>
                  <li> Analytics & Reporting</li>
                  <li> Wealth Screening </li>
                  <li>Constituent Management </li>
                  <li> Third-party integration</li>
                  <li> Task Management</li>
                  <li>Grantmaker Portal</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section class="our_purposeSection d-cta">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-md-10 text-center">
                <div class="largeTxt">
                  <h2 class="h2">Test drive at your end</h2>
                  <div>
                    No Credit Card required, simply use your Office 365 email
                    ID.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="strengthenView embraceView">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-md-12 col-lg-12 text-center">
                <h3 class="h1">
                  Embrace Common Data Model (CDM) across systems
                </h3>
                <p>
                  Powered by Azure and the Common Data Model (CDM) for
                  Nonprofits, with Right Cause you can integrate the donor data
                  from various sources, whether Microsoft systems or others,
                  into a unified digital loop of business intelligence and
                  reporting. Developed by Microsoft in collaboration with
                  nonprofit leaders and technology experts, the CDM standardizes
                  and interrelates data across applications, ensuring
                  consistency in how data is defined and reported. This
                  eliminates data siloes, allowing for secure data flow
                  throughout your Office 365 and Dynamics 365 ecosystem.{" "}
                </p>
              </div>
              <div class="col-lg-12 col-xl-10 col-md-12 offset-xl-1 text-center carouselBg">
                <div
                  id="carouselExampleDark"
                  class="carousel carousel-dark slide"
                  data-bs-ride="carousel"
                >
                  <div class="carousel-inner">
                    <div class="carousel-item active" data-bs-interval="10000">
                      {/* <picture>
                                                <source srcset="img/data-modal-img-1.webp" width="950" height="415" type="image/webp">
                                                <source srcset="img/data-modal-img-1.jpeg" type="image/jpeg">
                                                <img data-src="img/data-modal-img-1.jpeg" alt="Attract, retain, and expand donor base through personalized engagement." width="950"
                                                    height="415" src="img/data-modal-img-1.jpeg">
                                            </picture> */}
                      <img
                        alt="Right Cause Nonprofit Software"
                        src={DM1}
                        width="950"
                        height="415"
                      />
                      <div class="carousel-caption d-none d-md-block">
                        <h5>
                          Attract, retain, and expand donor base through
                          personalized engagement.{" "}
                        </h5>
                      </div>
                    </div>
                    <div class="carousel-item" data-bs-interval="2000">
                      {/* <picture>
                                                <source srcset="img/data-modal-img-2.webp" width="950" height="415" type="image/webp">
                                                <source srcset="img/data-modal-img-2.jpeg" type="image/jpeg">
                                                <img data-src="img/data-modal-img-2.jpeg" alt="Enhance fundraising efficiency and cut costs with automated processes. " width="950"
                                                    height="415" src="img/data-modal-img-2.jpeg">
                                            </picture> */}
                      <img
                        alt="Right Cause Nonprofit Software"
                        src={DM2}
                        width="950"
                        height="415"
                      />
                      <div class="carousel-caption d-none d-md-block">
                        <h5>
                          Enhance fundraising efficiency and cut costs with
                          automated processes.{" "}
                        </h5>
                      </div>
                    </div>
                    <div class="carousel-item">
                      {/* <picture>
                                                <source srcset="img/data-modal-img-3.webp" width="950" height="415" type="image/webp">
                                                <source srcset="img/data-modal-img-3.jpeg" type="image/jpeg">
                                                <img data-src="img/data-modal-img-3.jpeg" alt="Gain precise, real-time insights into fundraising and financial results."
                                                    width="950" height="415" src="data-modal-img-3.jpeg">
                                            </picture> */}
                      <img
                        alt="Right Cause Nonprofit Software"
                        src={DM3}
                        width="950"
                        height="415"
                      />
                      <div class="carousel-caption d-none d-md-block">
                        <h5>
                          Gain precise, real-time insights into fundraising and
                          financial results.
                        </h5>
                      </div>
                    </div>
                  </div>
                  <button
                    class="carousel-control-prev"
                    type="button"
                    data-bs-target="#carouselExampleDark"
                    data-bs-slide="prev"
                  >
                    <span
                      class="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                    <span class="visually-hidden">Previous</span>
                  </button>
                  <button
                    class="carousel-control-next"
                    type="button"
                    data-bs-target="#carouselExampleDark"
                    data-bs-slide="next"
                  >
                    <span
                      class="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span class="visually-hidden">Next</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="non-profitDiv" class="suitable-customers suit-cc">
          <div class="container">
            <div class="row">
              <div class="col-md-12 col-lg-12 text-center">
                <h2 class="h1">
                  Suitable for Nonprofits of all sizes and types
                </h2>
                <p>
                  Customizable Solution to suit your requirements. All are
                  delivered in secure Microsoft Cloud —the most secure,
                  reliable, and scalable cloud that truly integrates core
                  solutions for the specific needs of nonprofits.
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="infograph_wrapper">
                  <div class="infographFirst_div">
                    <div class="iconWrapper hospice">
                      <p class="iconName">Hospice</p>
                      <div class="icon_div">
                        <i class="icon-hospice"></i>
                      </div>
                    </div>
                    <div class="iconWrapper healthcare">
                      <p class="iconName">Healthcare</p>
                      <div class="icon_div">
                        <i class="icon-healthcare"></i>
                      </div>
                    </div>
                    <div class="iconWrapper welfare">
                      <p class="iconName">
                        Welfare
                        <br /> organizations
                      </p>
                      <div class="icon_div">
                        <span class="icon-welfare"></span>
                      </div>
                    </div>

                    <div class="iconWrapper chambers">
                      <p class="iconName">Chambers</p>
                      <div class="icon_div">
                        <i class="icon-chambers"></i>
                      </div>
                    </div>
                    <div class="iconWrapper membership">
                      <p class="iconName">Membership Associations</p>
                      <div class="icon_div">
                        <i class="icon-membership"></i>
                      </div>
                    </div>

                    <div class="iconWrapper churches">
                      <p class="iconName">
                        Churches &<br /> Religious
                        <br /> Institutes{" "}
                      </p>
                      <div class="icon_div">
                        <i class="icon-churches_1"></i>
                      </div>
                    </div>
                  </div>
                  <div class="infographSecond_div">
                    <div class="iconWrapper faith">
                      <p class="iconName">
                        Faith
                        <br />
                        charities
                      </p>
                      <div class="icon_div">
                        <i class="icon-faith"></i>
                      </div>
                    </div>
                    <div class="iconWrapper education">
                      <p class="iconName">
                        Education
                        <br /> establishments{" "}
                      </p>
                      <div class="icon_div">
                        <i class="icon-education"></i>
                      </div>
                    </div>
                    <div class="iconWrapper govt">
                      <p class="iconName">
                        Government
                        <br /> Agencies
                      </p>
                      <div class="icon_div">
                        <i class="icon-govt"></i>
                      </div>
                    </div>
                    <div class="iconWrapper student">
                      <p class="iconName">
                        Student
                        <br /> Union
                      </p>
                      <div class="icon_div">
                        <i class="icon-student"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="our_purposeSection d-cta">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-md-10 text-center">
                <div class="largeTxt">
                  <div>
                    Try it risk-free. No credit card required. See Right Cause
                    in action.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="reliablitydiv" class="rseSection rse-donation-sec-cc">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-md-12 col-lg-9 mt-4">
                <div class="d-flex w-100 verticalTabs">
                  <ul class="nav nav-tabs" id="myTab" role="tablist">
                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link active"
                        id="communication-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#communication"
                        type="button"
                        role="tab"
                        aria-controls="communication"
                        aria-selected="true"
                      >
                        <span class="icon-Full-Access"></span> Full-Access
                        Reporting
                      </button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link"
                        id="operability-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#operability"
                        type="button"
                        role="tab"
                        aria-controls="operability"
                        aria-selected="false"
                      >
                        <span class="icon-Cloud-Based"></span> Cloud-Based CRM
                        Solution
                      </button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link"
                        id="scalability-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#scalability"
                        type="button"
                        role="tab"
                        aria-controls="scalability"
                        aria-selected="false"
                      >
                        <span class="icon-integration"></span> Integration
                      </button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link"
                        id="security-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#security"
                        type="button"
                        role="tab"
                        aria-controls="security"
                        aria-selected="false"
                      >
                        <span class="icon-Native"></span>
                        Native Reporting / Deep Business Intelligence{" "}
                      </button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link"
                        id="compliance-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#compliance"
                        type="button"
                        role="tab"
                        aria-controls="compliance"
                        aria-selected="false"
                      >
                        <span class="icon-Compliance"></span>
                        Compliance and Monitoring Support
                      </button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link"
                        id="data-Security-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#data-security"
                        type="button"
                        role="tab"
                        aria-controls="Data Security"
                        aria-selected="false"
                      >
                        <span class="icon-Data-Security"></span>
                        Data Security and Backups
                      </button>
                    </li>
                  </ul>
                  <div class="tab-content" id="myTabContent">
                    <div
                      class="tab-pane fade show active"
                      id="communication"
                      role="tabpanel"
                      aria-labelledby="communication-tab"
                    >
                      <h3 class="h1">Full-Access Reporting </h3>
                      <p>
                        Run a report on any partner segment, for any date, in a
                        variety of helpful visualizations. These dashboards are
                        intuitive, easy-to-use, and comes with restricted access
                        to specific individual or teams.{" "}
                      </p>
                    </div>
                    <div
                      class="tab-pane fade"
                      id="operability"
                      role="tabpanel"
                      aria-labelledby="operability-tab"
                    >
                      <h3 class="h1">Cloud-Based CRM Solution</h3>
                      <p>
                        Embrace a Software as a Service (SaaS) model for
                        hassle-free management, eliminating the need for
                        on-premise infrastructure concerns.
                      </p>
                    </div>
                    <div
                      class="tab-pane fade"
                      id="scalability"
                      role="tabpanel"
                      aria-labelledby="scalability-tab"
                    >
                      <h3 class="h1">Integration</h3>
                      <p>
                        The Right Cause Donation Management System can be
                        integrated with your existing CRM system, financial
                        tools or any other software on demand.{" "}
                      </p>
                    </div>
                    <div
                      class="tab-pane fade"
                      id="security"
                      role="tabpanel"
                      aria-labelledby="security-tab"
                    >
                      <h3 class="h1">
                        Native Reporting / Deep Business Intelligence{" "}
                      </h3>
                      <p>
                        BI embedded throughout via multiple canned and scheduled
                        reports, robust ad-hoc reporting capabilities, and
                        easily customizable dashboards.
                      </p>
                    </div>
                    <div
                      class="tab-pane fade"
                      id="compliance"
                      role="tabpanel"
                      aria-labelledby="compliance-tab"
                    >
                      <h3 class="h1">Compliance and Monitoring Support </h3>
                      <p>
                        Real-time visibility into sub-recipient performance and
                        reporting is augmented by automated system checks,
                        validations, and alerts.
                      </p>
                    </div>
                    <div
                      class="tab-pane fade"
                      id="data-security"
                      role="tabpanel"
                      aria-labelledby="data-Security-tab"
                    >
                      <h3 class="h1">Data Security and Backups </h3>
                      <p>
                        HIPPA, FERPA, and FISMA compliant system built on secure
                        and scalable Microsoft Dynamics 365 platform.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="whyChooseUs">
          <div class="container">
            <div class="row">
              <div class="col-md-12 col-lg-12">
                <div class="whyChooseUs-content text-center">
                  <h2 class="h1 mt-xs-3 mb-3">Why Choose Us? </h2>
                  <p>
                    We’ll consult you on the most comprehensive, robust, and
                    complete Nonprofit CRM software solution that’s “ready to go
                    out of the box.” You won’t have to worry about being upsold
                    on extras or purchasing additional functions just to get it
                    to work. You get the flexibility to choose the features you
                    want, and request customizations as needed.
                  </p>
                  <p>
                    Partnering with us means forging a lasting relationship with
                    a trusted market leader specializing in technology solutions
                    for the nonprofit sector.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="our_purposeSection g-cta">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-md-10 text-center">
                <div class="largeTxt">
                  <h2 class="h2">See Right Cause in Action</h2>
                  <div>
                    Take guided tour of our Non-profit CRM Solution. Schedule a
                    demo call with our team followed by an interactive Q&A.
                    session.
                  </div>
                  <a
                    href="#getStrated"
                    class="greenBtn"
                    tabindex="0"
                    aria-label="Test Run the CRM at your end."
                  >
                    Request Demo
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Modal
        size="lg"
        show={show}
        onHide={handleClose}
        className="modal_getStartedForm"
      >
        <Modal.Header closeButton>
          The Right Cause Grant Accelerator
        </Modal.Header>
        {/* <Fcontact /> */}
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/Yby8S1ytbd4?si=TCMYPaoYIlRr6g67"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
      </Modal>
    </>
  );
};

export default DonationManagement;
